export class SelfEmployedModel {

    uid: string;
    concept: string;
    date: Date;
    amount: number;
    paided: Date;
    typePay: string;
    typePayBankAccount: string;
    fiscalYear: number;
    activityUid: string;
    accounted: string;
    efectivoId: string;
    partnersId: number;
    recargo: number; // recargo para el pago del autonomo
    polizaCreditoId: string;

    constructor() {
        this.recargo = 0;
    }
}
